export const clearTime = 500